import api from '../utils/api';

export const getHomeCarousal = async () => {
    try {
        const response = await api.get(`/homeCarousal`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getHomeCarousalId = async (id) => {
    try {
        const response = await api.get(`/homeCarousal/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const addHomeCarousal = async (formData) => {
    try {
        const response = await api.post(`/homeCarousal/add`, formData);
        if (response?.status === 201) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const updateHomeCarousal = async (formData, id) => {
    try {
        const response = await api.put(`/homeCarousal/${id}`, formData);    
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const deleteHomeCarousal = async (id) => {
    try {
        const response = await api.delete(`/homeCarousal/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

